<template>
<div>
	<div class="row">
		<div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-xs-12">
			<card class="card" :title="isNew ? 'Add user' : 'Edit user'">
				<loader :loading="loading_user">
					<form @submit.prevent v-if="!loading_user">
						<div class="row">
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Username"
										placeholder="Username"
										:v="$v.user.username"
										v-model="$v.user.username.$model">
								</fg-input>
							</div>
							<div class="col-xl-6 col-lg-6">
								<fg-input type="password"
										label="Password"
										placeholder="Password"
										:v="$v.user.password"
										v-model="$v.user.password.$model">
								</fg-input>
							</div>
						</div>
						
						<div class="row">
							<div class="col-xl-6 col-lg-6">
								<label>State</label>
								<select class="form-control" v-model="$v.user.active.$model">
									<option :value="1">Active</option>
									<option :value="0">Disactive</option>
								</select>
								</div>
							<div class="col-xl-6 col-lg-6">
								<label>Role</label>
								<select @input="onChangeRole" class="form-control" v-model="$v.user.id_role.$model">
									<option v-for="r in roles" :value="r.id_role" :key="r.id_role">{{r.description}}</option>
								</select>
							</div>
						</div>
			
						<template name="footer">
							<div class="row mt-4">
								<div class="col-4 text-left">
									<router-link to="/users">
										<p-button  type="link" round>
										Back
										</p-button>
									</router-link>
								</div>
								<div class="col-8 text-right">
									<p-button v-if="isNew || (!isNew && isModified)" :loading="loading_save || $v.user.$pending" type="success"
											round
											@click.native.prevent="saveUser">
									Save
									</p-button>
									<p-button v-if="!isNew && !isModified" :loading="loading_delete" type="danger"
											round
											@click.native.prevent="deleteUser">
									Delete
									</p-button>
								</div>
							</div>
						</template>
			
					</form>
				</loader>
			</card>
		</div>

	</div>

</div>
</template>
<script>

import {required,requiredIf,minLength} from 'vuelidate/lib/validators';

export default {
  	data(){
		return{
			user:{},
			current_username:null,
			roles:[],
			loading_user:false,
			loading_save:false,
			loading_delete:false,
		}
  	},
  	validations:{
		user:{
			username:{
				required,
				/*async isUnique(value){
					if (value === '' || value === null || value == this.current_username) return true;
					if(value!==undefined){
						let result = await this.$api.get('user/s/exist-username/'+this.user.username);
						if(result.data==0) return true;
						else return false;
					}
				}*/
			},
			password:{
				required:requiredIf(function(){
					return this.isNew;
				}),
				minLength: minLength(4)
			},
			active:{required},
			id_role:{required},
	  	}
  	},
  computed:{
	isNew(){
		return this.$route.params.id_user==='new'; 
	},
	isModified(){
		return this.$v.user.$anyDirty;
	},
	idUser(){
	  	return this.$route.params.id_user;
	}
  },
  methods:{
	/*user*/
	onChangeRole(event){
		if(event.target.value==3){
			this.user.type = 'S';
		}
		else{
			this.user.type = 'H';
		}
	},
	async loadUser(){
	  if(this.isNew){
		let result = {
		  data:{
			id_user:null,
			username:null,
			password:null,
			active:1,
			type:'H',
			id_role:null,
			api_key:null
		  }
		}
		this.user = result.data;
	  }
	  else{
		let result = await this.$api.get('user/'+this.idUser);
		this.user = result.data;
		this.current_username = result.data.username;
		this.user.password = null
	  }
	},
	async existUsername(){
		let result = await this.$api.get('user/s/exist-username/'+this.user.username);
		return result.data;
	},
	async saveUser(){
		this.$v.user.$touch();
		this.loading_save = true;
		
		if(await this.existUsername()==0 || this.user.username===this.current_username){
			
			if(!this.$v.user.$invalid){
				if(this.isNew){
					let result = await this.$api.post('user',this.user);
					this.user.id_user = result.data.id_user;
					//this.user.api_key = result.data.api_key;
				}
				else{
					let result = await this.$api.put('user/'+this.idUser,this.user);
					//this.user.api_key = result.data.api_key;
				}
				this.$toast.success({
					message:this.isNew ? 'User added' : 'user edited',
					icon: "ti-check"
				});
				if(this.isNew){
					this.$router.push({path:'/users/'+this.user.id_user});
				}
				this.current_username = this.user.username
				this.$v.user.$reset();
			}
			else{
				this.$toast.error({
					message:'Some fields must be completed',
					icon: "ti-face-sad"
				});
			}
			this.loading_save = false;
		}
		else{
			this.$toast.error({
				message:'Username exist',
				icon: "ti-face-sad"
			});
		}
		
	},
	async deleteUser(){
		try{
			this.loading_delete = true;
			await this.$api.delete('user/'+this.idUser);
			this.loading_delete = false;
			this.$toast.error({
				message:'User deleted',
				icon: "ti-check"
			});
			this.$router.push({path:'/users'});
		}
		catch(error){
			this.loading_delete = false;
			this.$toast.warning({
				message:'Not possible to delete this user',
				icon: "ti-alert",
			})
		}
	},
	/*role */
	async loadRoles(){
		let result = await this.$api.get('role');
		this.roles = result.data;
		if(this.isNew){
			this.user.id_role = this.roles[0].id_role
		}
	}
  },
  async beforeMount(){
	this.loading_user = true;
	await this.loadUser();
	await this.loadRoles();
	this.loading_user = false;
  }
};
</script>
<style>
</style>
